/* eslint-disable @tanstack/query/exhaustive-deps -- doesn't work with the key factory */
import { useQuery } from "@tanstack/react-query";

import { useAuth } from "~/providers/store/auth";

import { childrenKeys } from "../keys";
import { getChildren } from "../request";

/**
 * All students for the current till, used by the collect discovery page.
 * Reuses {@link getChildren} without a group filter (so it returns every
 * student), unlike {@link useChildren} which is scoped to a single group.
 */
export function useCollectStudents() {
  const { tillId } = useAuth();

  return useQuery({
    queryKey: childrenKeys.list(),
    queryFn: () => {
      if (!tillId) throw new Error("Till ID is required");

      return getChildren(tillId, { fields: ["collectionStatus"] });
    },
    enabled: Boolean(tillId),
    // Sort by name here so consumers get a stable, ready-to-render order.
    select: (children) =>
      [...children].sort((a, b) => a.name.localeCompare(b.name))
  });
}
